import instance from "api";
import { endpoints } from 'config';
import { get, post } from '../../../helpers/newMakeEndpointRequest';
import {
  BusinessCaseActivityDetails,
  BusinessCaseActivityMaterials,
  ParsedBusinessCaseActivityDetails,
  ParsedBusinessCaseActivityMaterials,
} from './models';

type ApiReturn<T = any> = {
  response: T | null;
  errors: any;
};

export const getBusinessCaseActivityDetails = async (params: {
  assessmentProngID: number;
}): Promise<any> => {
  const url = endpoints.businessCase.getBusinessCaseDetails;
  return await get(url, params);
};

export const postStartBusinessCaseTest = async (params: {
  assessmentProngID: number;
}): Promise<any> => {
  const url = endpoints.businessCase.getBusinessCaseDetails;
  return await get(url, params);
};

export const parseGetBusinessCaseActivityDetails = (
  details: BusinessCaseActivityDetails
): ParsedBusinessCaseActivityDetails => {
  const {
    businessCaseQuestions,
    businessCaseMaterials,
    clientID,
    description,
    instructions,
    materialReviewTime,
    name,
    businessCaseID,
    startTime,
    timeLimit,
    // wordLimit,
  } = details;
  return {
    businessCaseQuestions,
    businessCaseMaterials: parseBusinessCaseActivityMaterials(
      businessCaseMaterials
    ),
    clientID,
    introduction: description,
    instructions,
    materialReviewTime,
    name,
    businessCaseID,
    startTime,
    timeLimit,
  };
};

export const startBusinessCase = async (params: {
  assessmentProngID: number;
}): Promise<ApiReturn> => {
  const url = endpoints.businessCase.startBusinessCaseTest;
  return await post(url, params);
};

export const completeBusinessCase = async (params: {
  assessmentProngID: number;
}): Promise<ApiReturn> => {
  const url = endpoints.businessCase.completeBusinessCase;
  return await post(url, params);
};

export const parseBusinessCaseActivityMaterials = (
  businessCaseActivityMaterials: BusinessCaseActivityMaterials[]
): ParsedBusinessCaseActivityMaterials[] =>
  businessCaseActivityMaterials ? businessCaseActivityMaterials.map(
    ({
      materialsDocument,
      materialsDocumentName,
      materialsDocumentExtension,
    }) => ({
      name: `${materialsDocumentName}${materialsDocumentExtension}`,
      link: materialsDocument,
    })
  ) : [];

export const parseSaveBusinessCaseAnswer = (
  assessmentProngID: number,
  businessCaseQuestionID: number,
  answer: string,
  wordLimit: number | null
) => {
  let parsedAnswer = answer;

  if (wordLimit) {
    parsedAnswer = answer
      .trim()
      .split(' ')
      .slice(0, wordLimit)
      .join(' ')
      .trim();
  }
  return {
    assessmentProngID,
    businessCaseQuestionID,
    answer: parsedAnswer,
  };
};

export const saveBusinessCaseAnswer = async (params: {
  assessmentProngID: number;
  businessCaseQuestionID: number;
  answer: string;
}): Promise<ApiReturn> => {
  const url = endpoints.businessCase.saveCandidateAnswers;
  return await post(url, params);
};

// Get list of reasons for requesting a reasonable adjustment
export const getReasonableAdjustmentReasons = async () => {
  try {
    const res = await instance.get(
      endpoints.businessCase.getResonableAdjustmentReasons
    );
    if (res.data.status === '1') {
      return {
        response: res.data,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (res) {
    const error: any = res;

    if (error.response && error.response.data && error.response.data.errors) {
      return {
        response: null,
        errors: error.response.data.errors,
      };
    } else {
      return {
        response: null,
        errors: [],
      };
    }
  }
};

// Submit a request for a reasonable adjustment
export const requestReasonableAdjustment = async (payload: any) => {
  try {
    const res = await instance.post(
      endpoints.businessCase.requestResonableAdjustment,
      payload
    );
    if (res.data.status === '1') {
      return {
        response: res.data,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (res) {
    const error: any = res;

    if (error.response && error.response.data && error.response.data.errors) {
      return {
        response: null,
        errors: error.response.data.errors,
      };
    } else {
      return {
        response: null,
        errors: [],
      };
    }
  }
};
